<div class="phone-wrapper">

  <!-- ── PHONE FRAME ── -->
  <div class="phone-frame">

    <!-- Notch -->
    <div class="notch-area">
      <div class="notch"></div>
    </div>

    <!-- Status bar -->
    <div class="status-bar">
      <span class="status-time">9:41</span>
      <div class="status-icons">
        <span class="icon-signal">
          <span></span><span></span><span></span><span></span>
        </span>
        <span class="icon-wifi">
          <svg width="15" height="11" viewBox="0 0 15 11" fill="white">
            <path d="M7.5 2.8C9.8 2.8 11.9 3.7 13.4 5.2l1.1-1.1C12.9 2.4 10.3 1.3 7.5 1.3S2.1 2.4.5 4.1l1.1 1.1C3.1 3.7 5.2 2.8 7.5 2.8z"/>
            <path d="M7.5 5.3c-1.5 0-2.9.6-3.9 1.6l1.1 1.1c.7-.7 1.7-1.2 2.8-1.2s2.1.4 2.8 1.2l1.1-1.1C10.4 5.9 9 5.3 7.5 5.3z"/>
            <circle cx="7.5" cy="10" r="1.3"/>
          </svg>
        </span>
        <span class="icon-battery">
          <span class="battery-body">
            <span class="battery-level"></span>
          </span>
          <span class="battery-tip"></span>
        </span>
      </div>
    </div>

    <!-- Screen content -->
    <div class="ig-screen">

      <!-- ── COMMENTS TAB ── -->
      <ng-container *ngIf="activeTab === 'comments'">
        <div class="ig-post-mini">
          <div class="ig-sheet-handle"></div>
        </div>
        <div class="ig-comments-header">
          <span class="ig-comments-title">Comentarios</span>
          <span class="ig-dots-sm">&#8943;</span>
        </div>
        <div class="ig-comments-filter">Para ti &#8964;</div>
        <div class="ig-divider"></div>

        <!-- User comment -->
        <div class="ig-comment">
          <div class="ig-avatar-sm ig-avatar-grey"></div>
          <div class="ig-comment-body">
            <div class="ig-comment-meta">
              <span class="ig-comment-user">nombre_usuario</span>
              <span class="ig-comment-time">1 sem</span>
            </div>
            <span class="ig-comment-text">Me gusta 😍</span>
            <div class="ig-comment-actions">
              <span class="ig-comment-reply-link">Responder</span>
              <span class="ig-comment-reply-link">Ocultar</span>
            </div>
          </div>
          <div class="ig-heart-col">
            <span class="ig-heart">♡</span>
          </div>
        </div>

        <!-- Bot reply: una sola respuesta de ejemplo -->
        <div class="ig-comment ig-comment--reply" *ngIf="sendDm || sendPublicReply">
          <div class="ig-avatar-sm ig-avatar-sm--reply">
            <img *ngIf="profilePictureUrl" [src]="profilePictureUrl" alt="avatar" />
            <span *ngIf="!profilePictureUrl" class="ig-avatar-placeholder ig-avatar-placeholder--sm">
              {{ username.charAt(0).toUpperCase() }}
            </span>
          </div>
          <div class="ig-comment-body">
            <div class="ig-comment-meta">
              <span class="ig-comment-user">{{ username }}</span>
              <span class="ig-comment-time">Ahora</span>
            </div>
            <span *ngIf="sendPublicReply && publicReplyMessage" class="ig-comment-text">{{ publicReplyMessage }}</span>
            <span *ngIf="sendPublicReply && !publicReplyMessage" class="ig-placeholder-text">Escribe tu respuesta pública...</span>
            <span *ngIf="!sendPublicReply" class="ig-comment-text">Gracias por escribirnos 😊 Revisa tus DMs.</span>
          </div>
        </div>
      </ng-container>

      <!-- ── DM TAB ── -->
      <ng-container *ngIf="activeTab === 'dm'">
        <!-- DM conversation header -->
        <div class="ig-dm-header">
          <div class="ig-avatar-sm">
            <img *ngIf="profilePictureUrl" [src]="profilePictureUrl" alt="avatar" />
            <span *ngIf="!profilePictureUrl" class="ig-avatar-placeholder ig-avatar-placeholder--sm">
              {{ username.charAt(0).toUpperCase() }}
            </span>
          </div>
          <div class="ig-dm-header-info">
            <span class="ig-dm-username">{{ username }}</span>
            <span class="ig-dm-meta">Activo/a ahora</span>
          </div>
          <div class="ig-dm-header-icons">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9a16 16 0 0 0 6.91 6.91l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="23 7 16 12 23 17 23 7"/>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
            </svg>
          </div>
        </div>

        <div class="ig-divider"></div>

        <!-- Messages -->
        <div class="ig-dm-messages">
          <!-- System notice -->
          <span class="ig-dm-system">{{ username }} te envió un DM sobre un comentario en su publicación.</span>

          <!-- Bot message (left) -->
          <div class="ig-dm-row ig-dm-row--left">
            <div class="ig-avatar-xs">
              <img *ngIf="profilePictureUrl" [src]="profilePictureUrl" alt="avatar" />
              <span *ngIf="!profilePictureUrl" class="ig-avatar-placeholder" style="font-size: 8px;">
                {{ username.charAt(0).toUpperCase() }}
              </span>
            </div>
            <div class="ig-dm-bubble ig-dm-bubble--bot" *ngIf="sendDm && dmMessage; else noDmMessage">{{ dmMessage }}</div>
            <ng-template #noDmMessage>
              <div class="ig-dm-bubble ig-dm-bubble--bot ig-dm-bubble--placeholder">Escribe tu mensaje directo...</div>
            </ng-template>
          </div>

          <!-- User reply (right) -->
          <div class="ig-dm-row ig-dm-row--right">
            <div class="ig-dm-bubble ig-dm-bubble--user">Muchas gracias 😊</div>
          </div>
        </div>
      </ng-container>

    </div>

    <!-- Bottom area (emoji + input) — visible in comments tab -->
    <ng-container *ngIf="activeTab === 'comments'">
      <div class="ig-emoji-bar">
        <span>❤️</span><span>🙌</span><span>🔥</span>
        <span>💯</span><span>😮</span><span>😍</span><span>😂</span>
      </div>
      <div class="ig-divider"></div>
    </ng-container>

    <!-- DM input bar -->
    <ng-container *ngIf="activeTab === 'dm'">
      <div class="ig-divider"></div>
      <div class="ig-input-row">
        <div class="ig-dm-camera-btn">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="white" stroke="none">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <circle cx="12" cy="13" r="4" fill="#1a73e8"/>
          </svg>
        </div>
        <span class="ig-input-placeholder">Mensaje...</span>
        <div class="ig-dm-input-icons">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color:#a8a8a8">
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
            <line x1="12" y1="19" x2="12" y2="23"/>
            <line x1="8" y1="23" x2="16" y2="23"/>
          </svg>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color:#a8a8a8">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="16"/>
            <line x1="8" y1="12" x2="16" y2="12"/>
          </svg>
        </div>
      </div>
    </ng-container>

    <!-- Comments input row -->
    <ng-container *ngIf="activeTab === 'comments'">
      <div class="ig-input-row">
        <div class="ig-avatar-xs">
          <img *ngIf="profilePictureUrl" [src]="profilePictureUrl" alt="avatar" />
          <span *ngIf="!profilePictureUrl" class="ig-avatar-placeholder" style="font-size: 8px;">
            {{ username.charAt(0).toUpperCase() }}
          </span>
        </div>
        <span class="ig-input-placeholder">Añadir un comentario...</span>
      </div>
    </ng-container>

    <!-- Home indicator -->
    <div class="home-indicator"></div>
  </div>

  <!-- ── TAB BAR BELOW PHONE ── -->
  <div class="preview-tabs">
    <button
      class="preview-tab"
      [class.preview-tab--active]="activeTab === 'comments'"
      (click)="setTab('comments')"
    >Comentarios</button>
    <button
      class="preview-tab"
      [class.preview-tab--active]="activeTab === 'dm'"
      (click)="setTab('dm')"
    >DM</button>
  </div>

</div>
